// packages/web-ui/src/panels/views/theme-css.ts
//
// W4-S1 — Legacy CSS-variable injection helper. Inside the AppShell, Tailwind 4
// tokens (`packages/web-ui/src/styles/tokens.css` from W2-S1) win. This helper
// short-circuits when Tailwind has already provided variables via the
// `data-theme` attribute or when a previous injection inserted the `<style>`.

/**
 * Fallback CSS for hosts that mount the `<ViewRenderer>` outside the AppShell
 * (e.g. a Storybook-style dev harness). Mirrors the cream/taupe palette from
 * `tools/view-renderer/render-svg-direct.mjs` rather than the sandbox's
 * generic black/grey, per UX §15.
 */
// Audi-adapted diagram palette — pure white canvas, hairline mid-grey
// borders, near-black edges, mid-grey labels. Matches audi.com's
// approach to technical drawings (high-contrast monochrome with the
// red reserved for brand moments — not used in default diagram trim).
export const THEME_CSS = `
.tessa-view-renderer {
  --tessa-bg:          #FFFFFF;
  --tessa-bg-elev:     #F7F8FA;
  --tessa-bg-header:   #EEF1F5;
  --tessa-fg:          #1A1F2B;
  --tessa-muted:       #6B7280;
  --tessa-border:      #C3C9D2;
  --tessa-border-soft: #E3E7ED;
  --tessa-edge:        #334155;
  --tessa-label-bg:    #FFFFFF;
  --tessa-accent:      #2563EB;
  --tessa-canvas-dot:  #E3E7ED;
}
.tessa-view-renderer[data-theme='dark'] {
  --tessa-bg:          #0F141B;
  --tessa-bg-elev:     #161D27;
  --tessa-bg-header:   #1C2531;
  --tessa-fg:          #E6EAF0;
  --tessa-muted:       #9AA4B2;
  --tessa-border:      #3A4555;
  --tessa-border-soft: #2A3340;
  --tessa-edge:        #C3CAD6;
  --tessa-label-bg:    #0F141B;
  --tessa-accent:      #60A5FA;
  --tessa-canvas-dot:  #232C38;
}
`;

/**
 * Inject the legacy CSS once per document. Short-circuits inside the AppShell
 * because the renderer's local CSS file (`view-renderer.css`) and the W2-S1
 * Tailwind tokens already cover the variable surface.
 */
export function injectThemeCss(): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (root.dataset['theme'] !== undefined) return;
  if (document.getElementById('tessa-view-renderer-theme')) return;
  const style = document.createElement('style');
  style.id = 'tessa-view-renderer-theme';
  style.textContent = THEME_CSS;
  document.head.appendChild(style);
}
